import { StateBlock } from '@pulse-web-ui/state-block';
import { styled } from '@pulse-web-ui/theme';

export const StyledStateBlock = styled(StateBlock)`
  height: fit-content;
`;
